"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNullOrUndefined = void 0;
function isNullOrUndefined(data) {
    return data == null || data == undefined;
}
exports.isNullOrUndefined = isNullOrUndefined;
//# sourceMappingURL=utils.js.map